module.exports = __webpack_public_path__ + "img/IC.17730d5d.svg";